import React from 'react';
import cls from 'classnames';
import { Button } from 'antd';

export const ButtonComponent = (
  {
    className,
    text,
    onClick,
    ...props
  }) => {

  return (
    <Button onClick={onClick}
            className={cls(className, 'btn')}
            {...props}
    >
      {text}
      {props.children}
    </Button>
  );
};

export default ButtonComponent;
